import { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addScreenAction, updateScreenAction, resetAction } from "../actions";
import Icon from "../components/Icon";

function MobileBanner({ screens, reset, showSteps }) {
  const mobileBannerRef = useRef();

  useEffect(() => {
    const updateSticky = () => {
      const headerHeight = getComputedStyle(document.documentElement)
        .getPropertyValue('--trs-header-height')
        .trim();
      
      if (mobileBannerRef.current && headerHeight) {
        const width = window.innerWidth;
        const height = window.innerHeight;

        const isSpecificDevice = 
          (width === 1024 && height === 1366) ||
          (width === 853 && height === 1280) ||
          (width === 912 && height === 1368);
        
        if (isSpecificDevice) {
          mobileBannerRef.current.setAttribute('uk-sticky', '');
        } else {
          mobileBannerRef.current.setAttribute('uk-sticky', `offset: ${headerHeight}`);
        }
      }
    };

    updateSticky();
    window.addEventListener('resize', updateSticky);

    return () => {
      window.removeEventListener('resize', updateSticky);
    };
  }, []);

  return (
    <div 
      ref={mobileBannerRef}
      id="mobileBanner" 
      className="uk-hidden@m"
    >
      <div className="uk-container uk-container-expand uk-padding-small">
        <div className="uk-grid uk-grid-small uk-flex uk-flex-between uk-flex-middle">
          {!showSteps && (
            <div className="uk-text-left uk-width-1-2">
              <p className="step-status uk-margin-auto-right">
                <span>{screens.step}</span> | 6
              </p>
            </div>
          )}
          <div className="uk-flex uk-flex-middle uk-flex-left@m uk-width-1-2">
            <span
              className="start-over uk-link uk-margin-left uk-display-inline-block uk-margin-auto-left"
              uk-tooltip="title: Start Over"
              onClick={() => reset()}
            >
              <Icon iconName="start-over" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  screens: state.questions,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateScreen: updateScreenAction,
      addScreen: addScreenAction,
      reset: resetAction,
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(MobileBanner);